import { useMemo } from 'react';
import { useTheme } from 'foundations-theming/utils';
export function useV1FormThemeCss() {
  const theme = useTheme();
  return useMemo(() => {
    var _t$body200$fontFamil, _t$body, _t$heading300$fontFa, _t$heading, _br$;
    const c = theme.color;
    const t = theme.typography;
    const br = theme.borderRadius;
    const bodyFont = (_t$body200$fontFamil = (_t$body = t['body-200']) === null || _t$body === void 0 ? void 0 : _t$body.fontFamily) !== null && _t$body200$fontFamil !== void 0 ? _t$body200$fontFamil : 'inherit';
    const headingFont = (_t$heading300$fontFa = (_t$heading = t['heading-300']) === null || _t$heading === void 0 ? void 0 : _t$heading.fontFamily) !== null && _t$heading300$fontFa !== void 0 ? _t$heading300$fontFa : bodyFont;
    const radius = (_br$ = br['100']) !== null && _br$ !== void 0 ? _br$ : '0px';
    return dynamicClass => {
      const f = `form.hs-form.hs-form-private.hs-custom-style.${dynamicClass}`;
      return `
${f} { color: ${c['text-core-default']}; font-family: ${bodyFont}; }

${f} .hs-form-field { margin-bottom: 10px; }
${f} .hs-form-field label:not(.hs-error-msg) { color: ${c['text-core-default']}; font-family: ${bodyFont}; font-size: 13px; font-weight: 300; margin-bottom: 10px; display: block; }
${f} .hs-field-desc { color: ${c['text-core-subtle']}; }
${f} .hs-form-required { color: ${c['fill-alert-default']}; }

${f} .hs-form-field.field input.hs-input { color: ${c['text-core-default']}; background-color: ${c['fill-field-default']}; border: 1px solid ${c['border-core-default']}; border-radius: ${radius}; font-family: ${bodyFont}; font-size: 14px; line-height: 24px; padding: 12px 10px; height: 43px; box-sizing: border-box; }
${f} .hs-form-field.field input.hs-input:focus { box-shadow: 0 0 3px ${c['border-core-default']}; outline: none; }
${f} .hs-form-field textarea.hs-input:focus { box-shadow: 0 0 3px ${c['border-core-default']}; outline: none; }
${f} .hs-form-field select.hs-input:focus { box-shadow: 0 0 3px ${c['border-core-default']}; outline: none; }
${f} .hs-form-field.field input.hs-input::placeholder { color: ${c['text-core-subtle']}; }

${f} .hs-form-field textarea.hs-input { color: ${c['text-core-default']}; background-color: ${c['fill-field-default']}; border: 1px solid ${c['border-core-default']}; border-radius: ${radius}; font-family: ${bodyFont}; font-size: 14px; padding: 12px 10px; height: auto; min-height: 66px; }
${f} .hs-form-field textarea.hs-input::placeholder { color: ${c['text-core-subtle']}; }

${f} .hs-form-field select.hs-input { color: ${c['text-core-default']}; background-color: ${c['fill-field-default']}; border: 1px solid ${c['border-core-default']}; border-radius: ${radius}; font-family: ${bodyFont}; font-size: 14px; padding: 12px 10px; height: 43px; box-sizing: border-box; }

${f} .hs-form-field.field .inputs-list input[type="checkbox"],
${f} .hs-form-field.field .inputs-list input[type="radio"] { accent-color: ${c['fill-primary-default']}; height: auto; padding: 0; border: none; background: none; border-radius: 0; line-height: normal; }

${f} .hs-form-radio-display,
${f} .hs-form-checkbox-display { display: flex; align-items: center; gap: 6px; }

${f} .hs-button.primary { background-color: ${c['fill-primary-default']}; color: ${c['text-primary-default']}; border: none; border-radius: ${radius}; font-family: ${bodyFont}; font-size: 14px; font-weight: 700; padding: 12px 36px; height: auto; cursor: pointer; }
${f} .hs-button.primary:hover { opacity: 0.9; }

${f} .hs-richtext { color: ${c['text-core-default']}; font-family: ${headingFont}; }

${f} .hs-error-msg { color: ${c['fill-alert-default']}; }

${f} .submitted-message { color: ${c['text-core-default']}; font-family: ${bodyFont}; }

${f} .legal-consent-container { color: ${c['text-core-subtle']}; font-size: 12px; }
`;
    };
  }, [theme]);
}